import React from 'react';
import { Breadcrumbs } from './components/Breadcrumbs';
import { MEDIA_BREAKPOINTS } from '../../constants/MEDIA_BREAKPOINTS';
import { Images } from './components/Images/Images';
import { Heading } from './components/Heading';
import { ProductInfo } from './components/ProductInfo';
import { JsonLd } from './components-renderless/JsonLd';
import { DLProduct } from './components-renderless/DL.Product';
import { AddedModal } from './components/AddedModal/AddedModal';
import { RRouterSearchParamsProvider } from '../../contexts/RRouterSearchParamsContext/RRouter.SearchParams.Provider';
const isDesktop = MEDIA_BREAKPOINTS.LG_UP.matches;
export const ProductBlankApp = () => {
    return (React.createElement(RRouterSearchParamsProvider, { navProps: { replace: true } },
        React.createElement(JsonLd, null),
        React.createElement(Breadcrumbs, null),
        !isDesktop &&
            React.createElement(Heading, null),
        React.createElement("div", { className: "d:flex:lg-up" },
            React.createElement(Images, null),
            React.createElement(ProductInfo, null)),
        React.createElement(DLProduct, null),
        React.createElement(AddedModal, null)));
};
